import React from 'react';
const FileSvg = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="31"
      viewBox="0 0 30 31"
      fill="none"
      className={className}
      {...props}
    >
      <path
        d="M17.7907 28.4069H12.2093V30.4999H17.7907V28.4069ZM2.09302 18.2906V12.7092H8.99745e-07V18.2906H2.09302ZM27.9069 17.6807V18.2906H29.9999V17.6807H27.9069ZM19.0342 5.18987L24.5581 10.1613L25.9582 8.60561L20.4344 3.63415L19.0342 5.18987ZM29.9999 17.6807C29.9999 15.3248 30.021 13.8332 29.4266 12.4985L27.5147 13.35C27.8858 14.1834 27.9069 15.1399 27.9069 17.6807H29.9999ZM24.5581 10.1613C26.4465 11.861 27.1435 12.5166 27.5147 13.35L29.4266 12.4985C28.8322 11.1638 27.7093 10.1816 25.9582 8.60561L24.5581 10.1613ZM12.2509 2.59297C14.458 2.59297 15.2909 2.60912 16.0332 2.89398L16.7831 0.939901C15.5945 0.483791 14.2995 0.499949 12.2509 0.499949V2.59297ZM20.4344 3.63415C18.9191 2.27034 17.9716 1.39596 16.7831 0.939901L16.0332 2.89398C16.7758 3.17891 17.4021 3.72091 19.0342 5.18987L20.4344 3.63415ZM12.2093 28.4069C9.5486 28.4069 7.65837 28.4046 6.22443 28.2118C4.82058 28.0231 4.01177 27.6691 3.42125 27.0786L1.94126 28.5587C2.9855 29.6028 4.3096 30.0662 5.94554 30.2863C7.55136 30.5021 9.60777 30.4999 12.2093 30.4999V28.4069ZM8.99745e-07 18.2906C8.99745e-07 20.8921 -0.00221762 22.9485 0.21367 24.5543C0.433619 26.1902 0.89704 27.5144 1.94126 28.5587L3.42125 27.0786C2.83072 26.4881 2.47677 25.6792 2.28803 24.2755C2.09524 22.8415 2.09302 20.9512 2.09302 18.2906H8.99745e-07ZM17.7907 30.4999C20.3921 30.4999 22.4486 30.5021 24.0544 30.2863C25.6903 30.0662 27.0145 29.6028 28.0587 28.5587L26.5787 27.0786C25.9882 27.6691 25.1793 28.0231 23.7756 28.2118C22.3416 28.4046 20.4513 28.4069 17.7907 28.4069V30.4999ZM27.9069 18.2906C27.9069 20.9512 27.9047 22.8415 27.7118 24.2755C27.5232 25.6792 27.1692 26.4881 26.5787 27.0786L28.0587 28.5587C29.1029 27.5144 29.5663 26.1902 29.7863 24.5543C30.0022 22.9485 29.9999 20.8921 29.9999 18.2906H27.9069ZM2.09302 12.7092C2.09302 10.0485 2.09524 8.15832 2.28803 6.72437C2.47677 5.32053 2.83072 4.51172 3.42125 3.9212L1.94126 2.44121C0.89704 3.48544 0.433619 4.80954 0.21367 6.44549C-0.00221762 8.05131 8.99745e-07 10.1077 8.99745e-07 12.7092H2.09302ZM12.2509 0.499949C9.63539 0.499949 7.56894 0.497744 5.95655 0.713534C4.31486 0.933259 2.98631 1.39618 1.94126 2.44121L3.42125 3.9212C4.01096 3.3315 4.82226 2.97704 6.2342 2.78806C7.67545 2.59517 9.57641 2.59297 12.2509 2.59297V0.499949Z"
        fill={color}
      />
      <path
        d="M6.62793 18.9883H17.7907"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M6.62793 23.872H14.3023"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M16.3955 2.24414V5.7325C16.3955 9.02136 16.3955 10.6658 17.4172 11.6875C18.439 12.7092 20.0834 12.7092 23.3722 12.7092H28.9536"
        stroke={color}
        strokeWidth="2"
      />
    </svg>
  );
};

export default FileSvg;
